// extracted by mini-css-extract-plugin
export var bgImgClass = "RecommendedPosts-module--bgImgClass--ItyeU";
export var containerClass = "RecommendedPosts-module--containerClass--Mfjn9";
export var blogLinkClass = "RecommendedPosts-module--blogLinkClass--9CgMr";